export default __webpack_public_path__ + "static/media/acceso-lista-venta.88c1c5da.svg";